import React from 'react';
import { ShieldCheckIcon, DocumentTextIcon, BuildingOffice2Icon } from '@heroicons/react/24/outline';
import { PageHero } from '../components/page-templates/SitePageTemplates';

// Legal page. Per Org 52 feedback (Oct 2026) the site carries no separate privacy
// policy or terms text: TrueLog follows the Singapore Logistics Association's T&C.
const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-white">
      <PageHero
        eyebrow="Legal"
        title="Privacy policy and terms."
        highlight="Privacy policy"
        description="TrueLog follows the Terms and Conditions of the Singapore Logistics Association."
        heroIcon={ShieldCheckIcon}
        accentIcon={DocumentTextIcon}
        badges={['Singapore Logistics Association T&C', 'IATA Certified since 2019', 'FIATA Member']}
        metrics={[
          { value: '140+', label: 'Countries supported' },
          { value: '6', label: 'Global offices' },
          { value: '2019', label: 'IATA certified since' },
        ]}
        panelEyebrow="Legal"
        panelTitle="How TrueLog contracts"
        panelDescription="Our services are provided under the standard trading terms of the Singapore Logistics Association."
        panelItems={[
          {
            icon: BuildingOffice2Icon,
            title: 'Singapore Logistics Association',
            description: 'TrueLog follows the Terms and Conditions of the Singapore Logistics Association.',
          },
          {
            icon: DocumentTextIcon,
            title: 'Questions',
            description: 'Contact sales@truelog.com.sg for a copy of the applicable terms.',
          },
        ]}
      />

      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <p className="text-lg leading-8 text-slate-700">
            TrueLog follows the Terms and Conditions of the Singapore Logistics Association. For a copy of the applicable
            terms or any privacy enquiry, contact{' '}
            <a href="mailto:sales@truelog.com.sg" className="font-semibold text-[#0E9ED5] hover:underline">
              sales@truelog.com.sg
            </a>
            .
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
